import React from 'react';
import Avatar from '../../../../../../components/avatar';
import {textTruncation} from '../../../../../../utils';
import './index.css';

function ContactDetailsHead ({contactDetails}) {

	let textTruncationValue = 90;

	return (
		<div className="contact-details-head">
			<div className="d-flex align-items-center overflow-hidden flex-column flex-lg-row">
				<div className="position-relative mr-lg-4 mb-4 mb-lg-0">
					<Avatar
						className="flex-shrink-0"
						size={'10em'}
						src={
							contactDetails.imageString !== ''
								?
								contactDetails.hasImage
									?
									'data:image/png;base64,' + contactDetails.imageString
									:
									contactDetails.imageString
								:
								'https://lh3.googleusercontent.com/a/default-user=s96-p-k-rw-no'
						}
					/>
					{
						contactDetails.phoneContactEntry.type === "directory"
							?
							<svg className="directory-contact-icon" xmlns="http://www.w3.org/2000/svg" width="48"
								 height="48" viewBox="0 0 48 48" xmlSpace="preserve">
								<path fill="#001593"
									  d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
								<path
									d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z"
									fill="#FFF"/>
							</svg>
							:
							null
					}
				</div>
				<div className="text-center text-lg-left overflow-hidden">
					<h2 className="text-truncate">
						{
							contactDetails.phoneContactEntry.prefix !== undefined
								?
								contactDetails.phoneContactEntry.prefix + ' '
								:
								''
						}
						{
							contactDetails.phoneContactEntry.givenName !== undefined
								?
								contactDetails.phoneContactEntry.givenName
								:
								''
						}
						{
							contactDetails.phoneContactEntry.middleName !== undefined
								?
								' ' + contactDetails.phoneContactEntry.middleName
								:
								''
						}
						{
							contactDetails.phoneContactEntry.familyName !== undefined
								?
								' ' + contactDetails.phoneContactEntry.familyName
								:
								''
						}
						{
							contactDetails.phoneContactEntry.suffix !== undefined
								?
								' ' + contactDetails.phoneContactEntry.suffix
								:
								''
						}
					</h2>
					{
						contactDetails.phoneContactEntry.company && contactDetails.phoneContactEntry.jobTitle && contactDetails.phoneContactEntry.department &&
						<p title={`${contactDetails.phoneContactEntry.company} - ${contactDetails.phoneContactEntry.jobTitle} - ${contactDetails.phoneContactEntry.department}`}
						   className="text-truncate">
							<strong>{contactDetails.phoneContactEntry.company}</strong> — {contactDetails.phoneContactEntry.jobTitle} — {contactDetails.phoneContactEntry.department}
						</p>
					}
					{
						!contactDetails.phoneContactEntry.company && contactDetails.phoneContactEntry.jobTitle && contactDetails.phoneContactEntry.department &&
						<p title={`${contactDetails.phoneContactEntry.jobTitle} - ${contactDetails.phoneContactEntry.department}`}
						   className="text-truncate">
							{contactDetails.phoneContactEntry.jobTitle} — {contactDetails.phoneContactEntry.department}
						</p>
					}
					{
						!contactDetails.phoneContactEntry.company && !contactDetails.phoneContactEntry.jobTitle && contactDetails.phoneContactEntry.department &&
						<p title={`${contactDetails.phoneContactEntry.department}`} className="text-truncate">
							{contactDetails.phoneContactEntry.department}
						</p>
					}
					{
						contactDetails.phoneContactEntry.company && contactDetails.phoneContactEntry.jobTitle && !contactDetails.phoneContactEntry.department &&
						<p title={`${contactDetails.phoneContactEntry.company} - ${contactDetails.phoneContactEntry.jobTitle}`}
						   className="text-truncate">
							<strong>{contactDetails.phoneContactEntry.company}</strong> — {contactDetails.phoneContactEntry.jobTitle}
						</p>
					}
					{
						contactDetails.phoneContactEntry.company && !contactDetails.phoneContactEntry.jobTitle && !contactDetails.phoneContactEntry.department &&
						<p title={contactDetails.phoneContactEntry.company} className="text-truncate">
							<strong>{contactDetails.phoneContactEntry.company}</strong>
						</p>
					}
					{
						!contactDetails.phoneContactEntry.company && contactDetails.phoneContactEntry.jobTitle && !contactDetails.phoneContactEntry.department &&
						<p title={contactDetails.phoneContactEntry.jobTitle} className="text-truncate">
							{contactDetails.phoneContactEntry.jobTitle}
						</p>
					}
					{
						contactDetails.phoneContactEntry.description &&
						<p title={contactDetails.phoneContactEntry.description}
						   className="description">{textTruncation(contactDetails.phoneContactEntry.description, textTruncationValue)}</p>
					}
				</div>
			</div>
			<div className="d-flex align-items-center">
				{
					contactDetails?.phoneContactEntry?.emailAddresses &&
					<div className="text-center mx-2">
						<p className="text-nowrap mb-0">
							<a href={`https://calendar.google.com/calendar/u/0/r/eventedit?add=${contactDetails?.phoneContactEntry?.emailAddresses[0].email}&cls=0&hl=en`}
							   target="_blank"
							   rel="noreferrer">
								<svg
									width={20}
									height={20}
									viewBox="0 0 20 20"
								>
									<path
										d="M15.833 3.333h-0.833V1.667h-1.667v1.667H6.667V1.667H5v1.667H4.167c-0.925 0 -1.658 0.75 -1.658 1.667L2.5 16.667a1.667 1.667 0 0 0 1.667 1.667h11.667c0.917 0 1.667 -0.75 1.667 -1.667V5c0 -0.917 -0.75 -1.667 -1.667 -1.667m0 13.333H4.167V8.333h11.667z"/>
									<path d="M12.083 10.833a2.083 2.083 0 0 0 0 4.167 2.083 2.083 0 0 0 0 -4.167"/>
								</svg>
							</a>
						</p>
						<p>
							<a href={`https://calendar.google.com/calendar/u/0/r/eventedit?add=${contactDetails?.phoneContactEntry?.emailAddresses[0].email}&cls=0&hl=en`}
							   target="_blank"
							   rel="noreferrer">Schedule</a>
						</p>
					</div>
				}
				{
					contactDetails?.phoneContactEntry?.emailAddresses &&
					<div className="text-center mx-2">
						<p className="text-nowrap mb-0">
							<a href={"mailto:" + contactDetails?.phoneContactEntry?.emailAddresses[0].email}
							   target="_blank"
							   rel="noreferrer">
								<svg width="18" height="14" viewBox="0 0 18 14" fill="none"
									 xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd"
										  d="M0.0132028 4.15129C-3.38676e-10 4.69022 0 5.30205 0 6V8C0 10.8284 0 12.2426 0.87868 13.1213C1.75736 14 3.17157 14 6 14H12C14.8284 14 16.2426 14 17.1213 13.1213C18 12.2426 18 10.8284 18 8V6C18 5.30205 18 4.69022 17.9868 4.15129L9.97129 8.60436C9.36724 8.93994 8.63276 8.93994 8.02871 8.60436L0.0132028 4.15129ZM0.242967 2.02971C0.325845 2.05052 0.407399 2.08237 0.485643 2.12584L9 6.85604L17.5144 2.12584C17.5926 2.08237 17.6742 2.05052 17.757 2.02971C17.6271 1.55619 17.4276 1.18491 17.1213 0.87868C16.2426 0 14.8284 0 12 0H6C3.17157 0 1.75736 0 0.87868 0.87868C0.572448 1.18491 0.372942 1.55619 0.242967 2.02971Z"
										  fill="#314D60"/>
								</svg>
							</a>
						</p>
						<p><a href={"mailto:" + contactDetails?.phoneContactEntry?.emailAddresses[0].email}
							  target="_blank"
							  rel="noreferrer">Email</a></p>
					</div>
				}
				{
					contactDetails?.phoneContactEntry?.phoneNumbers &&
					<div className="text-center mx-2">
						<p className="text-nowrap mb-0">
							<a href={"tel:" + contactDetails?.phoneContactEntry?.phoneNumbers[0].number}
							   target="_blank"
							   rel="noreferrer">
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
									 xmlns="http://www.w3.org/2000/svg">
									<path
										d="M2.67962 1.32038L3.29289 0.707107C3.68342 0.316583 4.31658 0.316582 4.70711 0.707106L7.29289 3.29289C7.68342 3.68342 7.68342 4.31658 7.29289 4.70711L5.50048 6.49952C5.2016 6.7984 5.1275 7.255 5.31653 7.63307C6.40929 9.81858 8.18142 11.5907 10.3669 12.6835C10.745 12.8725 11.2016 12.7984 11.5005 12.4995L13.2929 10.7071C13.6834 10.3166 14.3166 10.3166 14.7071 10.7071L17.2929 13.2929C17.6834 13.6834 17.6834 14.3166 17.2929 14.7071L16.6796 15.3204C14.5683 17.4317 11.2257 17.6693 8.83698 15.8777L7.62857 14.9714C5.88504 13.6638 4.33622 12.115 3.02857 10.3714L2.12226 9.16302C0.330722 6.7743 0.568269 3.43173 2.67962 1.32038Z"
										fill="#314D60"/>
								</svg>
							</a>
						</p>
						<p><a href={"tel:" + contactDetails?.phoneContactEntry?.phoneNumbers[0].number}
							  target="_blank"
							  rel="noreferrer">Call</a></p>
					</div>
				}
			</div>

		</div>
	)
}

export default ContactDetailsHead;
